<template>
  <header
    :class="[
      'pageHeader',
      {
        'pageHeader--hideMobileSearch': isInitialMobileHideSearch,
      },
    ]"
  >
    <div class="pageHeader__inner container">
      <div class="pageHeader__logo">
        <span>
          <nuxt-link :to="localePath({ name: 'index' })">
            <logo />
            Ofix - zaopatrzenie dla home office oraz małych i dużych firm
          </nuxt-link>
        </span>
        <client-only>
          <div class="pageHeader__logoPlaceholder">
            <logo />
          </div>
        </client-only>
      </div>
      <div
        :class="{ 'pageHeader__categories--active': showCategoriesDropdown }"
        @mouseenter="showCategoriesDropdown = true"
        @mouseleave="showCategoriesDropdown = false"
        class="pageHeader__categories"
      >
        <button class="pageHeader__categoriesHamburger">
          <span />
          <span />
          <span />
        </button>
        <div class="pageHeader__categoriesDropdown">
          <div class="pageHeader__categoriesDropdownInner">
            <category-nav
              :categories="categoryMenuData"
              @close="showCategoriesDropdown = false"
              is-popup
            />
          </div>
        </div>
      </div>
      <header-search class="pageHeader__search" />
      <div class="pageHeader__links">
        <button
          @click="toggleSearch"
          class="pageHeader__link pageHeader__link--mobileSearch pageHeader__link--mobile"
        >
          <span class="pageHeader__linkIcon icon-search" />
        </button>
        <nuxt-link
          :to="
            $auth.isLogged()
              ? localePath({ name: 'dashboard-list' })
              : localePath({ name: 'shoppingList' })
          "
          class="pageHeader__link"
          rel="nofollow"
        >
          <div class="pageHeader__linkCount">
            <span class="pageHeader__linkIcon pageHeader__linkIcon--list icon-heart" />
            <span v-if="!$auth.isLogged()" class="pageHeader__linkNumber">
              <span v-if="defaultShoppingList">{{ defaultShoppingList.totalQuantity }}</span>
              <span v-else>0</span></span
            >
          </div>
          <span class="pageHeader__linkText">{{ $t('shopList') }}</span>
        </nuxt-link>
        <div class="pageHeader__link pageHeader__link--dropdown">
          <nuxt-link
            :to="localePath({ name: 'dashboard' })"
            class="pageHeader__linkInner"
            rel="nofollow"
          >
            <!--            <span class="pageHeader__linkIcon pageHeader__linkIcon&#45;&#45;avatar">-->
            <!--              <span v-if="unreadNotifications" class="pageHeader__iconLabel">-->
            <!--                {{ unreadNotifications }}-->
            <!--              </span>-->
            <!--            </span>-->
            <span
              :class="[
                `pageHeader__linkIcon icon-user`,
                { 'pageHeader__linkIcon--orange': businessVariables?.isPunchOutMode },
              ]"
            />
            <span
              class="pageHeader__linkText pageHeader__linkText--nameMaxWidth"
              v-if="$auth.isLogged()"
            >
              {{ $auth.getStoreUser().firstName }} {{ $auth.getStoreUser().lastName }}
            </span>
            <span class="pageHeader__linkText" v-else>{{ $t('myAccount') }}</span>
          </nuxt-link>
          <account-dropdown
            :menu-items="computedUserMenuData"
            :other-accounts="otherAccounts"
            :current-company="currentCompany"
            @switch-account="val => $emit('switch-account', val)"
            class="pageHeader__linkDropdown"
          />
        </div>
        <header-cart />
        <div @click="toggleMenu({ type: 'category' })" class="pageHeader__hamburger">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Logo from '~/components/Logo';
import AccountDropdown from '~/components/AccountDropdown';
import HeaderCart from '~/components/HeaderCart';
import HeaderSearch from '~/components/HeaderSearch';
import CategoryNav from '~/components/CategoryNav';
import listMixin from '~/mixins/list';

export default {
  name: 'PageHeader',
  components: {
    HeaderSearch,
    HeaderCart,
    AccountDropdown,
    Logo,
    CategoryNav,
  },
  mixins: [listMixin],
  props: {
    otherAccounts: {
      type: Array,
      default: () => [],
    },
    currentCompany: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      showCategoriesDropdown: false,
    };
  },
  computed: {
    ...mapState('layout', ['userMenuData', 'isInitialMobileHideSearch', 'categoryMenuData']),
    ...mapState('settings', ['businessVariables']),
    computedUserMenuData() {
      return this.userMenuData.map(item => ({
        ...item,
        slug: item.to ? item.to : item.href ? item.href : this.localePath({ name: item.slug }),
      }));
    },
  },
  methods: {
    ...mapMutations({
      toggleMenu: 'layout/toggleMenuOpened',
      toggleSearch: 'layout/toggleMobileSearchOpened',
    }),
  },
};
</script>
<style lang="scss">
.blog-template {
  .pageHeader {
    &--fixed {
      box-shadow: none;
    }
  }
}

.pageHeader {
  $root: &;
  position: sticky;
  padding: 2rem 0;
  top: 0;
  left: 0;
  width: 100%;
  background-color: $cWhite;
  z-index: $zHeader;
  transition: box-shadow $tr, padding $tr, transform $tr;
  border-bottom: 1px solid $cAddLight;

  @include rwd('ultra') {
    padding: 1.5rem 0;
    /*top: 35px;*/
  }

  @include rwd('tablet') {
    /*top: 0;*/
    /*position: fixed;*/
    padding: 1rem 0;
  }

  &__inner {
    display: flex;
    align-items: center;

    @include rwd('tablet') {
      flex-wrap: wrap;
    }
  }

  &__logo {
    position: relative;
    width: 13.1rem;
    height: 4.7rem;
    order: 1;
    text-indent: -1000em;

    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }

    @include rwd('ultra') {
      width: 11rem;
      height: 4rem;
    }

    @include rwd('laptop') {
      margin-right: 3rem;
    }

    @include rwd('small-laptop') {
      margin-right: 2rem;
    }

    @include rwd('tablet') {
      width: 10rem;
      height: 3.6rem;
    }

    @include rwd('small-phone') {
      width: 9rem;
      height: 3.2rem;
    }
  }

  &__logoPlaceholder {
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  &__categories {
    position: relative;
    order: 2;
    margin: 0 2rem 0 4rem;

    @include rwd('laptop') {
      margin: 0 2rem;
    }

    @include rwd('small-laptop') {
      display: none;
    }

    &--active {
      #{$root}__categoriesDropdown {
        opacity: 1;
        pointer-events: all;
      }

      #{$root}__categoriesHamburger {
        border-bottom: 1px solid $cWhite;
        border-radius: 4px 0 0 4px;
        box-shadow: 0 10px 20px rgba(23, 25, 51, 0.1);

        &:after {
          opacity: 1;
        }

        span {
          &:first-child {
            transform: rotate(45deg);
            top: 4px;
          }

          &:nth-child(2) {
            opacity: 0;
          }

          &:last-child {
            transform: rotate(-45deg);
            top: -4px;
          }
        }
      }
    }
  }

  &__categoriesDropdown {
    padding-top: 1rem;
    position: absolute;
    left: -170px;
    top: 100%;
    opacity: 0;
    pointer-events: none;
    transition: opacity $tr;
  }

  &__categoriesDropdownInner {
    min-width: 300px;
  }

  &__categoriesHamburger {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border: 1px solid $cAddLight;
    border-radius: 4px;
    width: 5rem;
    height: 5rem;
    box-shadow: 0 1px 1px rgba(23, 25, 51, 0.05);

    span {
      position: relative;
      display: block;
      width: 16px;
      height: 2px;
      margin: 1px;
      background-color: $cAddDark;
      transition: top $tr, transform $tr, opacity $tr;
    }

    &:after {
      content: '';
      position: absolute;
      z-index: 2;
      left: 0;
      top: 100%;
      height: 12px;
      width: 100%;
      background-color: $cWhite;
      border-left: 1px solid $cAddLight;
      border-right: 1px solid $cAddLight;
      opacity: 0;
    }
  }

  &__search {
    margin-right: 0.9rem;
    order: 3;

    @include rwd('tablet') {
      order: 3;
      flex: 0 0 100%;
      max-width: 100%;
      margin-top: 0.9rem;
      margin-right: 0;
      overflow: hidden;
      opacity: 1;
      //transition: margin-top $tr, opacity $tr;
    }
  }

  &__links {
    display: flex;
    align-items: center;
    order: 4;
    margin-left: auto;
    margin-right: -11px;

    @include rwd('laptop') {
      margin-right: 0;
    }

    @include rwd('small-laptop') {
      margin-right: -2rem;
    }

    @include rwd('tablet') {
      order: 2;
    }
  }

  &__link {
    display: inline-flex;
    align-items: center;
    position: relative;
    font-size: 1.4rem;
    line-height: 2.6rem;
    font-weight: 600;
    color: $cAddDark02;
    margin: 0 11px;

    @include rwd('laptop') {
      margin: 0 7px;
    }

    @include rwd('small-tablet') {
      margin: 0 2px;
    }

    @include rwd('small-phone') {
      margin: 0 1px;
    }

    &--dropdown {
      &:after {
        @include icomoon('chevron-down');
        font-size: 7px;
        color: $cMainNeutral;
        margin-left: 10px;
        transition: transform $tr;

        @include rwd('laptop') {
          display: none;
        }
      }

      &:hover {
        &:after {
          transform: rotate(180deg);
        }

        #{$root}__linkDropdown {
          top: 100%;
          opacity: 1;
          pointer-events: all;
        }
      }
    }

    &--mobileSearch {
      opacity: 0;
      pointer-events: none;
      transition: opacity $tr;
    }

    &--mobile {
      display: none;

      @include rwd('tablet') {
        display: block;
      }
    }
  }

  &__linkInner {
    display: inline-flex;
    align-items: center;
  }

  &__linkIcon {
    font-size: 2rem;
    color: $cMain;
    margin-right: 1rem;
    position: relative;

    &--orange {
      color: $cSec;
    }

    @include rwd('large-phone') {
      margin-right: 0.8rem;
    }

    &--list {
      font-size: 1.8rem;
      margin-right: 1.3rem;

      @include rwd('small-phone') {
        font-size: 1.7rem;
      }
    }

    @include rwd('small-phone') {
      font-size: 1.9rem;
    }

    &--avatar {
      width: 3.6rem;
      height: 3.6rem;
      border-radius: 50%;
      border: 1px solid $cAddLight;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url('../static/images/avatar.png');
      margin-right: 1.7rem;

      @include rwd('large-phone') {
        width: 3rem;
        height: 3rem;
        margin-right: 1rem;

        #{$root}__iconLabel {
          top: -0.3rem;
        }
      }
    }
  }

  &__iconLabel {
    position: absolute;
    right: -0.2rem;
    top: -0.1rem;
    transform: translateX(50%);
    width: 2rem;
    height: 2rem;
    padding-left: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    letter-spacing: 0.05em;
    font-weight: 800;
    color: $cWhite;
    background-color: $cSec;
    border-radius: 50%;
  }

  &__linkText {
    &--nameMaxWidth {
      max-width: 10rem;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;

      @include rwd('laptop') {
        max-width: 0;
      }
    }
    @include rwd('laptop') {
      display: none;
    }
  }

  &--hideMobileSearch {
    #{$root}__search {
      @include rwd('tablet') {
        display: none;
      }
    }
  }

  &--fixed {
    #{$root}__search {
      @include rwd('tablet') {
        height: 0;
        margin-top: 0;
        opacity: 0;
      }
    }
  }

  &--hideMobileSearch,
  &--fixed {
    padding: 2rem 0;

    @include rwd('ultra') {
      padding: 1.5rem 0;
    }

    @include rwd('tablet') {
      padding: 1rem 0;
    }

    #{$root}__link--mobileSearch {
      opacity: 1;
      pointer-events: all;
    }
  }

  &--fixed {
    box-shadow: 0 3px 20px 0 rgba(23, 25, 51, 0.07);

    #{$root}__linkDropdown {
      padding-top: 2.7rem;
    }

    .cartDropdown {
      padding-top: 2.7rem;

      @include rwd('ultra') {
        padding-top: 2.8rem;
      }
    }
  }

  &__linkCount {
    position: relative;
    top: 2px;
  }

  &__linkNumber {
    position: absolute;
    right: -0.8rem;
    top: 0.5rem;
    width: 2rem;
    height: 2rem;
    padding-left: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    letter-spacing: 0.05em;
    font-weight: 800;
    color: $cWhite;
    background-color: $cSec;
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }

  &__hamburger {
    display: none;
    margin-left: 2rem;
    padding: 0.5rem 2rem;
    border-left: 1px solid $cAddLight;

    @include rwd('small-laptop') {
      display: block;
    }

    @include rwd('tablet') {
      margin-left: 1rem;
    }

    @include rwd('small-tablet') {
      margin-left: 0;
      padding: 0.5rem 2rem 0.5rem 1.2rem;
    }

    span {
      display: block;
      margin: 4px 0;
      height: 2px;
      width: 20px;
      background-color: $cMain;
    }
  }

  &--searchPage {
    @include rwd('tablet') {
      box-shadow: 0 5px 15px rgba(23, 25, 51, 0.05);
    }
  }

  &--mobileHide {
    @include rwd('tablet') {
      transform: translateY(-69px);
    }
  }

  &--showLoader {
    z-index: $zIndexLoader + 1;
    box-shadow: 0 5px 15px rgba(23, 25, 51, 0.05);
  }
}
</style>
